import { config } from '@lib/config'
import { mixpanelStorage } from '@lib/mmkv/mmkv'
import { Mixpanel } from 'mixpanel-react-native'
import { Platform } from 'react-native'

let mixpanel: Mixpanel | undefined

export function initializeMixpanel(): void {
  if (config.mixpanelKey && config.mixpanelKey !== '-') {
    mixpanel = Platform.select({
      native: new Mixpanel(config.mixpanelKey, true),
      web: new Mixpanel(config.mixpanelKey, false, false, mixpanelStorage),
    })

    mixpanel?.init(false)
  }
}

export function identifyMixpanel(id: string): void {
  mixpanel?.identify(id)
  mixpanel?.getPeople().set('name', id)
}

export { mixpanel }
